import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { fonts } from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${fluid(32, 56)};
`;
const TitleSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;

  h1 {
    ${fonts.DaxPro.Bold};
    font-size: ${fluid(30, 38)};
    line-height: ${fluid(40, 50)};
    color: var(--theme);
    margin: 0;
  }

  p {
    ${fonts.DaxPro.Regular};
    font-size: ${fluid(18, 22)};
    line-height: 30px;
    margin: 0;
    color: ${brand.grey.grey20};
  }
`;
const ContactRegion = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${fluid(16, 32)};

  h2 {
    ${fonts.DaxPro.Bold};
    font-size: ${fluid(23, 27)};
    line-height: 22px;
    color: var(--theme);
    margin: 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  li {
    display: flex;
    align-items: center;
    gap: 16px;

    a {
      ${fonts.DaxPro.Medium};
      color: ${brand.grey.grey20};
      text-decoration: underline;
      font-size: ${fluid(20, 24)};
      line-height: ${fluid(25, 30)};
    }

    svg {
      color: var(--theme);
      width: ${fluid(32, 50)};
      height: ${fluid(32, 50)};
    }
  }
`;
export const ContactSectionStyles = {
    Container,
    TitleSection,
    ContactRegion,
};
